/* eslint-disable no-shadow */
import Korona from '../assets/svg/partnersT2C/korona.svg'
import RIA from '../assets/svg/partnersT2C/ria.svg'
import Western from '../assets/svg/partnersT2C/western.svg'
import Inteli from '../assets/svg/partnersT2C/inteli.svg'
import Smith from '../assets/svg/partnersT2C/smith.svg'
import MoneyGram from '../assets/svg/partnersT2C/moneygram.svg'

export enum Step {
  main,
  otp,
  success,
  error,
}

export enum Partners {
  Smith = 'Smith&Smith',
  Unistream = 'Unistream',
  WesternUnion = 'Western Union',
  ZolotayaKorona = 'Zolotaya Korona',
  Inteliexpress = 'Inteliexpress',
  Ria = 'RIA',
  MoneyGram = 'MoneyGram',
}

export const PartnersTypes = [
  {
    name: Partners.Smith,
    icon: Smith,
  },
  // {
  //   name: Partners.Unistream,
  //   icon: Unistream,
  // },
  {
    name: Partners.WesternUnion,
    icon: Western,
  },
  // {
  //   name: Partners.ZolotayaKorona,
  //   icon: Korona,
  // },
  {
    name: Partners.Inteliexpress,
    icon: Inteli,
  },
  {
    name: Partners.Ria,
    icon: RIA,
  },
  {
    name: Partners.MoneyGram,
    icon: MoneyGram,
  },
  // {
  //     name: 'primeste banii prin transfer',
  //     nameTranslate: 't2c-page.infoBlock.partners.description8',
  // }
]
